import script from "./BaseLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseLink.vue?vue&type=script&setup=true&lang=ts"

import "./BaseLink.vue?vue&type=style&index=0&id=9fce5588&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fce5588"]])

export default __exports__